module.exports = __webpack_public_path__ + "static/media/itemdisableselecao.3b32cc8a.png";